export default "__VITE_ASSET__CGtjbMdq__"